<template>

  <div class="container">

    <div class="row">

      <div class="col-12 offset-0 col-md-6 offset-md-3 text-center mb-5">

        <h4 class="mb-4 menu-dark font-weight-light">Add Bank Account</h4>

        <p class="">Please fill in the form below to add a bank account.</p>

        <b-form @submit.stop.prevent="addBankAccount" class="text-left text-white mt-3">

          <b-alert v-if="error" show variant="danger">
            <h4 class="alert-heading">Error</h4>
            <p class="alert-danger">
              {{error}}
            </p>
          </b-alert>

          <div class="row">

            <div class="col-12 col-md-4">

              <b-form-group  label="Account Type" label-for="account_type">
                <b-form-select
                  id="account_type"
                  name="account_type"
                  v-model="$v.form.account_type.$model"
                  :options="options.account_type"
                  :state="validateState('account_type')"
                ></b-form-select>

                <b-form-invalid-feedback>This is a required field.</b-form-invalid-feedback>
              </b-form-group>

            </div>

            <div class="col-12 col-md-8">

              <b-form-group label="Account Name" label-for="account_name">

                <b-form-input
                  id="account_name"
                  name="account_name"
                  placeholder="Joe/Jane Bloggs"
                  v-model="$v.form.account_name.$model"
                  :state="validateState('account_name')"
                ></b-form-input>

                <b-form-invalid-feedback>This is a required field</b-form-invalid-feedback>

              </b-form-group>

            </div>

            <div class="col-12 col-md-6">

              <b-form-group label="Account Number" label-for="account_number">

                <b-form-input
                  id="account_number"
                  name="account_number"
                  placeholder="00000000000"
                  v-model="$v.form.account_number.$model"
                  :state="validateState('account_number')"
                ></b-form-input>

                <b-form-invalid-feedback>This is a required field</b-form-invalid-feedback>

              </b-form-group>

            </div>

            <div class="col-12 col-md-6">

              <b-form-group label="Routing Number/Sort Code" label-for="routing_number">

                <b-form-input
                  id="routing_number"
                  name="routing_number"
                  placeholder="00000000000"
                  v-model="$v.form.routing_number.$model"
                  :state="validateState('routing_number')"
                ></b-form-input>

                <b-form-invalid-feedback>This is a required field</b-form-invalid-feedback>

              </b-form-group>

            </div>

            <div class="col-12 col-md-6">

              <b-form-group  label="Account Country" label-for="country">
                <b-form-select
                  id="country"
                  name="country"
                  v-model="$v.form.country.$model"
                  :options="options.country"
                  :state="validateState('country')"
                ></b-form-select>

                <b-form-invalid-feedback>This is a required field.</b-form-invalid-feedback>
              </b-form-group>

            </div>

            <div class="col-12 col-md-6">

              <b-form-group  label="Account Currency" label-for="currency">
                <b-form-select
                  id="country"
                  name="country"
                  v-model="$v.form.currency.$model"
                  :options="options.currency"
                  :state="validateState('currency')"
                ></b-form-select>

                <b-form-invalid-feedback>This is a required field.</b-form-invalid-feedback>
              </b-form-group>

            </div>

          </div>

          <b-form-group class="text-center mt-2">

            <b-button type="submit" variant="success mx-auto mt-2 px-4">
              Add Bank Account
            </b-button>

          </b-form-group>

        </b-form>
        
      </div>

    </div>

  </div>

</template>

<script src="https://js.stripe.com/v3/"></script>

<script>

import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, requiredUnless } from "vuelidate/lib/validators";


export default {
  name: 'Account',
  mixins: [validationMixin],
  data() {
    return  {
      error: null,
      stripe: undefined,
      form: {
        account_name: null,
        account_number: null,
        routing_number: null,
        country: null,
        currency: null,
        account_type: null
      },
      options: {
        account_type: [
          {
            id: 'individual',
            text: 'Personal',
          },
          {
            id: 'company',
            text: 'Company',
          }
        ],
        currency: [],
        countries: []
      },
    }
  },
  computed: {
    RoutingNumberRequired() {
      if (this.currency === 'eur') {
        return false;
      } else {
        return true;
      }

    }
  },
  validations: {
    form: {
        account_name: {
          required
        },
        account_number: {
          required
        },
        routing_number: {
          required: requiredUnless('RoutingNumberRequired'),
        },
        country: {
          required
        },
        currency: {
          required
        },
        account_type: {
          required
        }
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    loadData () {

      let token = null;

      try {
        token = this.$store.getters.getToken.access
      } catch (err) {
        this.$router.replace({name: 'auth-error'})
      }
      

      //localStorage.getItem('accessToken')
      let headers = {
        'Authorization': 'JWT ' + token
      }

      axios.get('/chipin/account/bank-accounts/?type=form', {'headers': headers})
          .then(res => {
            console.log(res.data)
            this.options = res.data.options
          })
          .catch(error => {
            this.name = 'Sorry something went wrong!';
            console.log(error)
          });

    },
    addBankAccount () {

      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      this.error = null;
      var self = this;


      this.stripe.createToken('bank_account', {
        country: this.form.country,
        currency: this.form.currency,
        routing_number: this.form.routing_number,
        account_number: this.form.account_number,
        account_holder_name: this.form.account_name,
        account_holder_type: this.form.account_type,
      })
      .then(function(result) {

        // Handle result.error or result.token
        if (result.token) {

          let token = null;

          try {
            token = self.$store.getters.getToken.access
          } catch (err) {
            self.$router.replace({name: 'auth-error'})
          }

          //localStorage.getItem('accessToken')
          let headers = {
            'Authorization': 'JWT ' + token
          }

          axios.post('/chipin/account/bank-accounts/', {
            "stripe_token": result.token.id
          }, {'headers': headers})
              .then(res => {
                
                self.$router.replace({name: 'bank-account'})

              })
              .catch(error => {
                this.name = 'Sorry something went wrong!';
                self.error = 'Sorry something went wrong!';
              });

        } else if (result.error) {
          // parse error and show to user
          
          var msg = result.error.message;
          self.error = msg

        }
      });

    }
  },
  beforeMount(){
    this.loadData()

      try {
        token = this.$store.getters.getStripeType
      } catch (err) {
        this.$router.replace({name: 'auth-error'})
      }

    var spk = null
    if (this.whatStripeAccount === 'ssh') {
      spk = process.env.VUE_APP_STRIPE_KEY
    } else {
      spk = process.env.VUE_APP_STRIPE_TCLLC_KEY
    }

    this.elements = stripe.elements();
    this.card = undefined;

    this.stripe = Stripe(spk);

   }
}
</script>
